import React, { useEffect } from 'react';
// import { Form, Checkbox, Select, Input } from 'antd';
import dayjs from 'dayjs';
import moment from 'moment';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {
  // Input,
  Row,
  Col,
  Select,
  Form,
  Radio,
  DatePicker,
  // Typography,
  Button,
  TimePicker,
  Progress,
  message,
  Input
} from 'antd';
// import AboutMe from './AboutMe';
// import Education from './Education';
import styles from './styles.module.less';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { getCityDetails } from '../../EditEducationsDetails/redux/slice';
import { createhoroscopeDetails } from '../redux/slice';
import { event } from '../../../utilities/gtag';
// const { Text } = Typography;

dayjs.extend(customParseFormat);

const Edit = ({
  country_codes,
  state_details,
  city_details,
  user_data
  // star_details,
  // rasi_details
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { createhoroscopeDetailsloading } = useSelector(
    (state) => state.edithoroscope
  );

  const params = useParams();
  // const handleSaveChanges = () => {
  //   form.submit(); // Triggers the form validation and submission
  // };

  console.log('Profile_ID:', params.id);

  const onFinish = async (values) => {
    event({
      action: 'profile_creation', // event name
      category: 'Horoscope Creation',
      label: 'Profile Form Submitted',
      value: 1
    });
    console.log('Edit_Horoscope_details', values);

    const formatDOB = (dob) => {
      return dob ? dayjs(dob).format('DD-MM-YYYY') : null;
    };

    const formatTimeOfBirth = (time) => {
      if (!time) return null;
      return dayjs(time).format('hh:mm A');
    };

    const payload = {
      profile_id: params.id,
      country_id: values.country,
      state_id: values.state,
      city_id: values.city,
      // star_sign_id: values.starSign,
      horoscope_match: values.horoscopeMatching,
      home_town_details: values.village,
      // dob: values.dob ? String(values.dob).split('T')[0] : null,
      // dob_time: `${values.hours}:${values.minutes} ${values.ampm}`,
      // dob_time: values.timeOfBirth,
      dob_time: formatTimeOfBirth(values.timeOfBirth),
      // dob: values.dob,
      dob: formatDOB(values.dob)
      // rashi_id: values.rasi
    };

    // console.log('Payload_Horoscope', payload);
    try {
      console.log('Form Submitted:', payload);
      const response = await dispatch(createhoroscopeDetails(payload)).unwrap(); // Dispatch Redux action
      if (response?.success) {
        // localStorage.setItem('profile_id', response.profile_id); // Store profile ID
        // navigate(`/editcontact/${response.profile_id}`); // Redirect on success
        message.success(response.message || 'Form submitted successfully!');
        navigate(`/editcontact`);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      message.error(
        error?.message || 'Failed to submit the form. Please try again.'
      );
    }
  };

  // const [form] = Form.useForm();
  // Tabs Data //
  const routes = {
    'About Me': '/editprofile',
    'Family Details': '/editfamily',
    'Education & Career': '/editeducation',
    Horoscope: '/edithoroscope',
    Contact: '/editcontact',
    'Desired Partner': '/editpartner',
    Membership: '/membership_payment'
  };
  const handleSectionClick = (section) => {
    if (routes[section]) {
      navigate(routes[section]);
    }
  };
  const activeTab = Object.entries(routes).find(
    ([, path]) => location.pathname === path
  )?.[0];

  // Tabs Data

  const matUserData = localStorage.getItem('MAT-User');
  const matUserObject = JSON.parse(matUserData);
  const userName =
    matUserObject.user_details.first_name +
    ' ' +
    matUserObject.user_details.last_name;

  // const parseDOB = (dob) => {
  //   if (!dob) return null;
  //   // Convert from "DD-MM-YYYY" to "YYYY-MM-DD" (ISO format for dayjs)
  //   const [day, month, year] = dob.split('-');
  //   return dayjs(`${year}-${month}-${day}`);
  // };

  // const parseDOB = (dob) => {
  //   if (!dob) return null;
  //   const parsed = dayjs(dob, ['DD-MM-YYYY', 'YYYY-MM-DD'], true);
  //   return parsed.isValid() ? parsed : null;
  // };

  const parseTime = (time) => {
    if (!time) return null;
    const parsedTime = dayjs(time, 'h:mm A');
    return parsedTime.isValid() ? parsedTime : null;
  };

  useEffect(() => {
    if (user_data?.Profiles?.[0]?.ProfileHoroscopes?.[0]) {
      const {
        dob,
        dob_time,
        Country,
        State,
        City,
        home_town_details,
        // star_sign,
        horoscope_match
      } = user_data.Profiles[0].ProfileHoroscopes[0];

      // const star_sign =
      //   user_data?.Profiles?.[0]?.ProfileHoroscopes?.[0]?.StarSign?.id;
      // const rasi = user_data?.Profiles?.[0]?.ProfileHoroscopes?.[0]?.Rashi?.id;

      form.setFieldsValue({
        dob: dob ? moment(dob, ['DD-MM-YYYY', 'YYYY-MM-DD'], true) : null,
        timeOfBirth: parseTime(dob_time),
        country: Country?.id,
        state: State?.id,
        city: City?.id,
        // starSign: star_sign,
        // rasi: rasi,
        village: home_town_details,
        horoscopeMatching: horoscope_match
      });
    }
  }, [user_data]);

  const percent = user_data?.user_score;
  // const conicColors = {
  //   '0%': '#87d068',
  //   '50%': '#ffe58f',
  //   '100%': '#ffccc7'
  // };
  const getStrokeColor = (percent) => {
    if (percent <= 30) return '#ff4d4f'; // Red
    if (percent <= 50) return '#fa8c16'; // Orange
    if (percent <= 80) return '#fadb14'; // Yellow
    return '#52c41a'; // Green
  };
  // const matUserData = localStorage.getItem('MAT-User');
  // const matUserObject = JSON.parse(matUserData);
  // const profile_unique_id = matUserObject?.user_details?.profile_unique_id;

  const handleCityChange = (cityId) => {
    form.setFieldsValue({ state: '', country: '' }); // Clear previous values
    fetchStateAndCountry(cityId); // Fetch new values
  };

  const fetchStateAndCountry = async (cityId) => {
    try {
      const response = await dispatch(getCityDetails(cityId));
      console.log('Full Response:', response); // Debug full response structure

      // Check if the response contains valid data
      if (response?.payload?.data) {
        const { State } = response.payload.data; // Ensure accurate destructuring

        if (State) {
          // Safely update form values
          form.setFieldsValue({
            // state: State?.state || '',
            // country: State?.Country?.country || ''
            state: State?.id || '',
            country: State?.Country?.id || ''
          });
        } else {
          message.error('State information is missing.');
        }
      } else {
        message.error('Failed to fetch state and country.');
      }
    } catch (error) {
      console.error('Error fetching details:', error);
      message.error('Error fetching details.');
    }
  };

  return (
    <div className={styles.maincontainer}>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <div className={styles.editOuter}>
          {/* <div className={styles.ButtonSet}>
            <button className={styles.primaryButton}>Back</button>
          </div> */}
          <div className={styles.singleContainer}>
            <Row
              gutter={24}
              style={{ width: '100%' }}
              className={styles.aboutimgstyles}
            >
              <Col
                xl={7}
                lg={24}
                md={24}
                sm={24}
                xs={24}
                className={styles.leftspace}
              >
                <div className={styles.leftimgcontainer}>
                  {/* <img src={LeftImg} /> */}
                  <div className={styles.overlayText}>
                    <h2 className={styles.title}>THE TALE OF</h2>
                    <h1 className={styles.bigTitle}>TWO</h1>
                  </div>
                </div>
              </Col>
              <Col
                xl={16}
                lg={24}
                md={24}
                sm={24}
                xs={24}
                className={styles.leftspace}
              >
                <div className={styles.detailSide}>
                  <div className={styles.detailName}>
                    <div className={styles.nameflex}>
                      <div className={styles.idname}>
                        <h1 className={styles.dName}> {userName} </h1>
                        {/* <span> {profile_unique_id} </span> */}
                      </div>
                      {/* <div className={styles.matchpercent}>
                        <h6>
                          <span>96%</span> Away to find the right match
                        </h6>
                      </div> */}
                      <Row gutter={[8, 8]} wrap>
                        <Col className={styles.progressname}>
                          <Progress
                            size="small"
                            type="circle"
                            percent={percent}
                            // strokeColor={conicColors}
                            strokeColor={getStrokeColor(percent)}
                          />
                          <h6 className={styles.matchpercent}>
                            away to find your life partner
                          </h6>
                        </Col>
                      </Row>
                    </div>
                    <div className={styles.changes}>
                      {/* <button
                  type="submit"
                  onClick={handleClick}
                  className={styles.saveBtn}
                >
                  Save changes
                </button> */}
                      {/* <div className={styles.textContainer}>
                        <img
                          src={EditIcon}
                          alt="Edit Profile"
                          className={styles.icon}
                        />
                        <div>Edit</div>
                      </div> */}

                      {/* <div className={styles.vBorder}></div>

                      <div className={styles.textContainer}>
                        <img
                          src={downloadIcon}
                          alt="Download Profile"
                          className={styles.icon}
                        />
                        <div>Download</div>
                      </div> */}
                    </div>
                  </div>
                  <div>
                    <div className={styles.detailsOuter}>
                      <div className={styles.detailsInner}>
                        <div className={styles.detailsInside}>
                          {/* Tabs Content */}
                          <div className={styles.searchTab}>
                            {Object.keys(routes).map((section) => (
                              <div
                                key={section}
                                className={`${styles.searchTabHeader} ${
                                  activeTab === section ? styles.activeTab : ''
                                }`}
                                onClick={() => handleSectionClick(section)}
                              >
                                {section}
                              </div>
                            ))}
                          </div>
                          {/* Tabs Content */}

                          <div>
                            <Row gutter={16}>
                              {/* Date of Birth */}
                              <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                                {/* <Text className={styles.labels}>
                                  <span style={{ color: 'red' }}>*</span> Date
                                  of Birth
                                </Text> */}
                                <Form.Item
                                  label="Date of Birth"
                                  name="dob"
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Please select date of birth!'
                                    }
                                  ]}
                                  style={{ paddingTop: '5px' }}
                                >
                                  {/* <DatePicker
                                    format="DD / MM / YYYY"
                                    style={{ width: '100%', color: '#d20b0b' }}
                                    className={styles.dateOne}
                                    placeholder="DD / MM / YYYY"
                                  /> */}
                                  {/*  */}
                                  {/* <DatePicker
                                    format="DD / MM / YYYY"
                                    value={
                                      form.getFieldValue('dob')
                                        ? dayjs(form.getFieldValue('dob'))
                                        : null
                                    }
                                    onChange={(date) =>
                                      form.setFieldsValue({ dob: date })
                                    }
                                    style={{ width: '100%', color: '#d20b0b' }}
                                    className={styles.dateOne}
                                    placeholder="DD / MM / YYYY"
                                  /> */}
                                  {/*  */}
                                  <DatePicker
                                    format="DD / MM / YYYY"
                                    value={
                                      form.getFieldValue('dob')
                                        ? moment(form.getFieldValue('dob')) // ✅ Ensure it's a moment object
                                        : null
                                    }
                                    onChange={(date) => {
                                      form.setFieldsValue({
                                        dob: date ? moment(date) : null
                                      }); // ✅ Convert to moment
                                    }}
                                    style={{ width: '100%' }}
                                    className={styles.dateOne}
                                    placeholder="Select date of birth (DD / MM / YYYY)"
                                  />
                                </Form.Item>
                              </Col>

                              {/* Time of Birth */}
                              <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                                {/* <Text className={styles.labels}>
                                  Time of Birth
                                </Text> */}
                                <Row gutter={24}>
                                  <Col span={24}>
                                    {/* <Form.Item
                                      name="hours"
                                      rules={[
                                        { required: true, message: 'Required' }
                                      ]}
                                      style={{ paddingTop: '5px' }}
                                    >
                                      <Select
                                        placeholder="Hours"
                                        className={styles.selectBox}
                                      >
                                        {[...Array(12).keys()].map((h) => (
                                          <Select.Option
                                            key={h + 1}
                                            value={h + 1}
                                          >
                                            {h + 1}{' '}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>
                                    <Form.Item
                                      name="minutes"
                                      rules={[
                                        { required: true, message: 'Required' }
                                      ]}
                                      style={{ paddingTop: '5px' }}
                                    >
                                      <Select
                                        placeholder="Minutes"
                                        className={styles.selectBox}
                                      >
                                        {[...Array(60).keys()].map((m) => (
                                          <Select.Option key={m} value={m}>
                                            {m}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                  <Col span={8}>
                                    <Form.Item
                                      name="ampm"
                                      rules={[
                                        { required: true, message: 'Required' }
                                      ]}
                                      style={{
                                        paddingTop: '5px',
                                        width: '70%'
                                      }}
                                    >
                                      <Select
                                        placeholder="AM/PM"
                                        className={styles.ampm}
                                      >
                                        <Select.Option value="AM">
                                          AM
                                        </Select.Option>
                                        <Select.Option value="PM">
                                          PM
                                        </Select.Option>
                                      </Select>
                                    </Form.Item> */}
                                    <Form.Item
                                      label="Time of Birth"
                                      name="timeOfBirth"
                                      rules={[
                                        { required: true, message: 'Required' }
                                      ]}
                                      style={{ paddingTop: '5px' }}
                                    >
                                      <TimePicker
                                        use12Hours
                                        format="h:mm A" // 12-hour format with AM/PM
                                        placeholder="Select time of birth"
                                        className={styles.selectBox}
                                      />
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <Row gutter={16}>
                              {/* Place of Birth */}
                              <Col span={24}>
                                {/* <Text className={styles.labels}>
                                  Place of Birth
                                </Text> */}
                                <div className={styles.thirdHeading}>
                                  Place of Birth
                                </div>
                                <Row gutter={8}>
                                  <Col xl={6} lg={6} md={6} sm={24} xs={24}>
                                    <Form.Item
                                      label="Village/Town"
                                      name="village"
                                      className={styles.labels}
                                      rules={[
                                        {
                                          required: true,
                                          message: 'Enter village'
                                        }
                                      ]}
                                    >
                                      <Input
                                        placeholder="Enter village/town name"
                                        className={styles.sign}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xl={6} lg={6} md={6} sm={24} xs={24}>
                                    <Form.Item
                                      name="city"
                                      label="City"
                                      rules={[
                                        {
                                          required: true,
                                          message: 'Please select city'
                                        }
                                      ]}
                                    >
                                      <Select
                                        placeholder="Select city"
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                          option.children
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                        }
                                        onChange={handleCityChange}
                                      >
                                        {city_details?.length
                                          ? city_details?.map((city, index) => {
                                              return (
                                                <option
                                                  value={city?.id}
                                                  key={index}
                                                >
                                                  {city?.city}
                                                </option>
                                              );
                                            })
                                          : ''}
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                  <Col xl={6} lg={6} md={6} sm={24} xs={24}>
                                    <Form.Item
                                      label="State"
                                      name="state"
                                      rules={[
                                        {
                                          required: true,
                                          message: 'Please select state'
                                        }
                                      ]}
                                    >
                                      <Select
                                        disabled
                                        placeholder="Select state"
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                          option.children
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                        }
                                      >
                                        {state_details?.length
                                          ? state_details?.map(
                                              (scode, index) => {
                                                return (
                                                  <option
                                                    value={scode?.id}
                                                    key={index}
                                                  >
                                                    {scode?.state}
                                                  </option>
                                                );
                                              }
                                            )
                                          : ''}
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                  <Col xl={6} lg={6} md={6} sm={24} xs={24}>
                                    <Form.Item
                                      label="Country"
                                      name="country"
                                      rules={[
                                        {
                                          required: true,
                                          message: 'Please select country'
                                        }
                                      ]}
                                    >
                                      <Select
                                        disabled
                                        placeholder="Select country"
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                          option.children
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                        }
                                      >
                                        {country_codes?.length
                                          ? country_codes?.map(
                                              (code, index) => {
                                                return (
                                                  <option
                                                    value={code?.id}
                                                    key={index}
                                                  >
                                                    {code?.country}
                                                  </option>
                                                );
                                              }
                                            )
                                          : ''}
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row gutter={16} align="middle">
                              {/* Star Sign */}
                              {/* <Col xl={7} lg={7} md={7} sm={24} xs={24}>
                                <Form.Item
                                  name="starSign"
                                  label="Star Sign"
                                  rules={[
                                    { required: false, message: 'Required' }
                                  ]}
                                >
                                  <Select
                                    placeholder="Select star sign"
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      option.children
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                  >
                                    {star_details?.length
                                      ? star_details?.map((star, index) => {
                                          return (
                                            <option
                                              value={star?.id}
                                              key={index}
                                            >
                                              {star?.star_sign}
                                            </option>
                                          );
                                        })
                                      : ''}
                                  </Select>
                                </Form.Item>
                              </Col>

                              <Col xl={7} lg={7} md={7} sm={24} xs={24}>
                                <Form.Item
                                  name="rasi"
                                  label="Rasi"
                                  rules={[
                                    { required: false, message: 'Required' }
                                  ]}
                                >
                                  <Select
                                    placeholder="Select rasi"
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      option.children
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                  >
                                    {rasi_details?.length
                                      ? rasi_details?.map((rasi, index) => {
                                          return (
                                            <option
                                              value={rasi?.id}
                                              key={index}
                                            >
                                              {rasi?.zodiac_sign}
                                            </option>
                                          );
                                        })
                                      : ''}
                                  </Select>
                                </Form.Item>
                              </Col> */}

                              {/* Horoscope Matching */}
                              <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                                {/* <Text className={styles.labels}>
                                  Horoscope Matching
                                </Text> */}
                                <Form.Item
                                  name="horoscopeMatching"
                                  label="Horoscope Matching"
                                  className={styles.labels}
                                  rules={[
                                    { required: true, message: 'Required' }
                                  ]}
                                >
                                  <Radio.Group>
                                    <Row className={styles.radiobuttons}>
                                      <Col span={8}>
                                        <Radio value="Important">
                                          Important
                                        </Radio>
                                      </Col>
                                      <Col span={8}>
                                        <Radio value="Preferable">
                                          Preferable
                                        </Radio>
                                      </Col>
                                      <Col span={8}>
                                        <Radio value="Not Necessary">
                                          Not Necessary
                                        </Radio>
                                      </Col>
                                    </Row>
                                  </Radio.Group>
                                </Form.Item>
                              </Col>
                            </Row>
                          </div>
                          <Form.Item>
                            <Button
                              type="primary"
                              htmlType="submit"
                              className={styles.submitbutton}
                              loading={createhoroscopeDetailsloading}
                              disabled={createhoroscopeDetailsloading}
                            >
                              Save & Next
                            </Button>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default Edit;
